export function getFormatedData (obj) {
    const returned_data = []

    if (obj) {
        Object.keys(obj).forEach( key => {
            const data = {...obj[key], key }
            returned_data.push(data)
        })
    }
    return returned_data

}
